import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "antd";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const PaymentError = () => {
  const query = useQuery();
  const reason = query.get("reason") || "Unknown error";
  const navigate = useNavigate();

  return (
    <div style={{
      minHeight: "100vh",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      background: "#fff"
    }}>
      <div style={{
        background: "#ff4d4f",
        borderRadius: "50%",
        width: 100,
        height: 100,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginBottom: 32
      }}>
        <svg width="60" height="60" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="12" fill="#ff4d4f"/><path d="M8 8l8 8M16 8l-8 8" stroke="#fff" strokeWidth="2.5" strokeLinecap="round"/></svg>
      </div>
      <h2 style={{ fontWeight: 700, marginBottom: 8, color: "#ff4d4f" }}>Payment Failed</h2>
      <div style={{ fontSize: 16, marginBottom: 8, color: "#222" }}>
        Your payment was cancelled or failed.
      </div>
      <div style={{ fontSize: 15, color: "#555", marginBottom: 32 }}>
        Reason: <b>{reason}</b>
      </div>
      <Button type="primary" size="large" style={{ borderRadius: 6, minWidth: 200 }} onClick={() => navigate("/my-courses")}>Back to My learning</Button>
    </div>
  );
};

export default PaymentError; 